'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
var isDesktop = $(document).width() > 1024;

module.exports = function () {
    if (isDesktop) {
        $(document).on('mouseover', '.left-container a', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $id = $this.attr('id');
            var $mainParent = $this.closest('.custom-drop-down-menu');
            $mainParent.find('.right-container').removeClass('show');
            $mainParent.find('.right-container.' + $id).addClass('show');
        });
    }
    keyboardAccessibility(
        document,
        {
            27: function (scope) {
                // escape
                if (scope.hasClass('show-module')) {
                    scope.removeClass('show-module');
                    $('html, body').removeAttr('style');
                    $('body').removeClass('side-panel-open');
                }
            },
        },
        function () {
            var $popover = $(this);
            if ($('body').hasClass('side-panel-open')) {
                if ($('.js-mini-cart-module').hasClass('show-module')) {
                    $popover = $('.js-mini-cart-module');
                } else if ($('.js-login-register-module').hasClass('show-module')) {
                    $popover = $('.js-login-register-module');
                }
            }
            return $popover;
        }
    );
    $(document).on('click', '.side-panels', function (e) {
        if ($(e.target).hasClass('show-module')) {
            $(e.target).removeClass('show-module');
            $('html, body').removeAttr('style');
            $('body').removeClass('side-panel-open');
        }
    });

    if (isDesktop) {
        document
            .querySelectorAll('.sub-menu-drop')
            .forEach(function (menu, menuIndex, menuArray) {
                // Select all focusable elements within the .sub-menu-drop
                var items = menu.querySelectorAll(
                    'a, button, input, [tabindex]:not([tabindex="-1"])'
                );

                items.forEach(function (item, index) {
                    // Add a keydown event listener to each focusable element
                    item.addEventListener('keydown', function (event) {
                        switch (event.key) {
                            case 'ArrowDown':
                                event.preventDefault();
                                // Move focus to the next item, or the first item if we're at the end
                                var nextItem = items[(index + 1) % items.length];
                                nextItem.focus();
                                break;
                            case 'ArrowUp':
                                event.preventDefault();
                                // Move focus to the previous item, or the last item if we're at the start
                                var previousItem =
									items[(index - 1 + items.length) % items.length];
                                previousItem.focus();
                                break;
                            case 'ArrowRight':
                                event.preventDefault();
                                // Move focus to the first focusable element in the next .sub-menu-drop
                                var nextMenu = menuArray[(menuIndex + 1) % menuArray.length];
                                var nextMenuItems = nextMenu.querySelectorAll(
                                    'a, button, input, [tabindex]:not([tabindex="-1"])'
                                );
                                if (nextMenuItems.length > 0) {
                                    nextMenuItems[0].focus();
                                }
                                break;
                            case 'ArrowLeft':
                                event.preventDefault();
                                // If it's the first sub-menu, move focus to the .left-container-ul
                                if (menuIndex === 0) {
                                    console.log(menu.parentElement.parentElement);
                                    var leftContainer =
										menu.parentElement.parentElement.querySelector(
										    '.left-container-ul'
										);
                                    var leftContainerItems = leftContainer.querySelectorAll(
                                        'a, button, input, [tabindex]:not([tabindex="-1"])'
                                    );
                                    if (leftContainerItems.length > 0) {
                                        leftContainerItems[0].focus();
                                    }
                                } else {
                                    // Otherwise, move focus to the first focusable element in the previous .sub-menu-drop
                                    var previousMenu =
										menuArray[
										    (menuIndex - 1 + menuArray.length) % menuArray.length
										];
                                    var previousMenuItems = previousMenu.querySelectorAll(
                                        'a, button, input, [tabindex]:not([tabindex="-1"])'
                                    );
                                    if (previousMenuItems.length > 0) {
                                        previousMenuItems[0].focus();
                                    }
                                }
                                break;
                            case 'Escape':
                                event.preventDefault();
                                // Find the parent .nav-item
                                var parentNavItem = item.closest('.nav-item');
                                if (parentNavItem) {
                                    // Find all focusable elements within the parent .nav-item
                                    var navItemItems = parentNavItem.querySelectorAll(
                                        'a, button, input, [tabindex]:not([tabindex="-1"])'
                                    );
                                    if (navItemItems.length > 0) {
                                        // Move focus to the first focusable element within the parent .nav-item
                                        navItemItems[0].focus();
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    });
                });
            });

        // Select all .left-container-ul elements
        document.querySelectorAll('.left-container-ul').forEach(function (menu) {
            // Select all focusable elements within the .left-container-ul
            var items = menu.querySelectorAll(
                'a, button, input, [tabindex]:not([tabindex="-1"])'
            );

            items.forEach(function (item, index) {
                item.setAttribute('tabindex', index);
                // Add a keydown event listener to each focusable element
                item.addEventListener('keydown', function (event) {
                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault();
                            // Move focus to the next item, or the first item if we're at the end
                            var nextItem = items[(index + 1) % items.length];
                            nextItem.focus();
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            // Move focus to the previous item, or the last item if we're at the start
                            var previousItem =
								items[(index - 1 + items.length) % items.length];
                            previousItem.focus();
                            break;
                        case 'ArrowRight':
                            event.preventDefault();
                            // Find the .right-container
                            var rightContainer =
								menu.parentElement.parentElement.querySelector(
								    '.right-container'
								);
                            if (rightContainer) {
                                // Find the first .sub-menu-drop within the .right-container
                                var submenu = rightContainer.querySelector('.sub-menu-drop');
                                if (submenu) {
                                    // Make the .sub-menu-drop visible
                                    submenu.style.display = 'block';
                                    // Find all focusable elements within the .sub-menu-drop
                                    var submenuItems = submenu.querySelectorAll(
                                        'a, button, input, [tabindex]:not([tabindex="-1"])'
                                    );
                                    if (submenuItems.length > 0) {
                                        // Move focus to the first focusable element within the .sub-menu-drop
                                        submenuItems[0].focus();
                                    }
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
            });
        });
    }
};
